export default {"src":"/_next/static/media/white-chat-icon.b71232e3.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};